import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserInfo } from '../models';
import { ListResult } from '../models/list-result';
import { WorkflowSubmissionReview } from '../models/workflow-submission-review.model';
import { WorkflowSubmission } from '../models/workflow-submission.model';
import { DataService } from './abstract-services/data.service';
import { UserService } from './user.service';

type ProducibleModel = {
    producer_id?: string;
    producerId?: string; // We should have only one with "producerId" but due to flaw within "angular2-jsonapi" we try to get one of them.
    author?: UserInfo;
};
@Injectable()
export class WorkflowSubmissionService extends DataService<WorkflowSubmission> {
    apiUrl = 'module_manager/v1/admin/workflowsubmissions';

    constructor(
        protected http: HttpClient,
        private userService: UserService,
    ) {
        super();
    }

    review$(submissionId: string, workflowReview: WorkflowSubmissionReview): Observable<Object> {
        return this.http.patch(`${this.endpoint}/${submissionId}`, workflowReview);
    }

    async getById(id: string): Promise<WorkflowSubmission> {
        const result = await super.getById(id);
        await this.fillAuthorInfo([result.workflow, ...result.workflow.modules]);
        return result;
    }

    async getList(): Promise<ListResult<WorkflowSubmission>> {
        const params = new HttpParams().set('state', 'inReview').set('page[number]', '1').set('page[size]', '1000');
        const result = await super.getList(params);
        await this.fillAuthorInfo(result.data);

        return new ListResult(result.data, result.totalCount);
    }

    protected createNewInstance(): WorkflowSubmission {
        return new WorkflowSubmission();
    }

    private async fillAuthorInfo(entities: ProducibleModel[]): Promise<void> {
        const ids = entities.map(entity => entity.producerId || entity.producer_id);

        if (ids != null && ids.length > 0) {
            const userInfos = ids.length ? await this.userService.getUserInfos$(ids as string[]).toPromise() : [];
            // @ts-ignore
            entities.forEach(entity => (entity.author = userInfos.find(user => user.id === entity.producer_id || user.id === entity.producerId)));
        }
    }
}
